import { Newspaper as icon } from "lucide-react"
import edit from "./blogs.edit"
// import list from './blogs.list'
import show from "./blogs.show"
import { BlogRecord } from "./blogs.types"

const crud = (permissions: Record<string, string[]>) => ({
  name: "blogs",
  options: { label: "Blogs" },
  show:
    "blogs" in permissions && permissions.blogs.includes("show")
      ? show
      : undefined,
  //   list:
  //     'blogs' in permissions && permissions.blogs.includes('list')
  //       ? list
  //       : undefined,
  edit:
    "blogs" in permissions && permissions.blogs.includes("edit")
      ? edit
      : undefined,
  icon,

  recordRepresentation: (record: BlogRecord): string => record.title,
})

export default crud
